import { Modal } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import useUpdateBlocktrainStatus from '../../../hooks/blocktrain/useUpdateBlocktrainStatus'
import { BlockTrainStatusEnum } from '../../../types'

interface BlocktrainModalProps {
  close: () => void
  status: BlockTrainStatusEnum
  id: number | string
}

const UpdateStatusConfirm: FC<BlocktrainModalProps> = ({ id, close, status }) => {
  const { t } = useTranslation()
  const { updateBlocktrainStatus, updateBlocktrainStatusIsFetching } = useUpdateBlocktrainStatus()

  const onOk = () => {
    updateBlocktrainStatus({ id, status })
    close()
  }

  return (
    <Modal
      title={t(`status_update_modal_title.${status}`)}
      open
      onCancel={() => {
        close()
      }}
      className="entity-modal"
      okText={t(`status_update_confirm_button.${status}`)}
      cancelText={t('cancel')}
      onOk={onOk}
      okButtonProps={{ loading: updateBlocktrainStatusIsFetching }}
    >
      <h3>{t('cannot_undone_advice')}</h3>
    </Modal>
  )
}

export default UpdateStatusConfirm
